"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deviceTypeFactory = void 0;
var models_1 = require("./models");
var phoneMatcher = /mobile/i;
var tabletMatcher = /iPad|Android|Touch/i;
var isMobile = function (userAgent) {
    return phoneMatcher.test(userAgent) ? models_1.DeviceType.Phone : null;
};
var isTablet = function (userAgent) {
    return tabletMatcher.test(userAgent) ? models_1.DeviceType.Tablet : null;
};
var isDesktop = function (userAgent) {
    return userAgent ? models_1.DeviceType.Desktop : null;
};
var detectUserAgent = function (navigator) {
    return navigator ? navigator.userAgent : "";
};
var create = function (navigator) {
    var userAgent = detectUserAgent(navigator);
    var deviceType = isMobile(userAgent) || isTablet(userAgent) || isDesktop(userAgent);
    return deviceType || models_1.DeviceType.Unknown;
};
exports.deviceTypeFactory = {
    create: create,
};
